// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6387b27","455":"704833f0","946":"dd4f82c1"}[chunkId] + ".chunk.js";
};